module.exports = __webpack_public_path__ + "img/car-icon.3441b4e7.svg";